import React from 'react'
import Masonry from 'react-masonry-css'
import TaskCard from './TaskCard'
import Grid from '@mui/material/Grid'

const MyTaskCardView = ({
  tasks,
  deleteTask,
  setIsDelegateOpen,
  setTask,
  setProcessReferenceNumber,
  teamDetails,
  breakpoints,
  visibleData,
}) => {
  return (
    <Masonry
      breakpointCols={breakpoints}
      className="my-masonry-grid task-card-container dflex-sec"
      columnClassName="my-masonry-grid_column taskcardwidth"
    >
      {tasks?.map((task) => (
        <div className="mb-3" key={task.process_id}>
          <TaskCard
            task={task}
            deleteTask={deleteTask}
            setIsDelegateOpen={setIsDelegateOpen}
            setTask={setTask}
            setProcessReferenceNumber={setProcessReferenceNumber}
            teamDetails={teamDetails}
            visibleData={visibleData}
          />
        </div>
      ))}
    </Masonry>
  )
}

export default MyTaskCardView
